import { createContext, useContext, useState } from 'react';

import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';
import type { MarketTrends } from '@widget/core/types';

export type MarketTrendsContextType = {
  marketTrends: MarketTrends | undefined;
  fetchMarketTrends: (zipCode: string) => void;
};

const MarketTrendsContext = createContext<MarketTrendsContextType | undefined>(undefined);

export const MarketTrendsProvider: ReactFCWithChildren<any> = ({ children }) => {
  const [marketTrends, setMarketTrends] = useState<MarketTrends | undefined>();

  const fetchMarketTrends = async (zipCode: string) => {
    try {
      const response = await fetch(`/api-widget/market/zipcode?zipcode=${zipCode}`);
      const data = await response.json();

      if (data.error) {
        setMarketTrends(undefined);
      } else {
        setMarketTrends(data.data as MarketTrends);
      }
    } catch {
      setMarketTrends(undefined);
    }
  };

  return (
    <MarketTrendsContext.Provider value={{ marketTrends, fetchMarketTrends }}>
      {children}
    </MarketTrendsContext.Provider>
  );
};

export const useMarketTrends = () => {
  const marketTrendsContext = useContext(MarketTrendsContext);

  if (!marketTrendsContext) {
    throw new Error('The useMarketTrends hook must be used within the MarketTrendsProvider');
  }

  return marketTrendsContext;
};
